import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';


import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { CreditActionTypes } from '../actions/credit.actions';
import { SummaryCreditModel } from '../../models/summary-credit.model';
import { CreditService } from '../../services/credit.service';
import { LoadCreditsFailure, LoadCredits,LoadCreditsSuccess,LoadCredit,LoadCreditFailure,LoadCreditSuccess,UpdateCredit,UpdateCreditFailure,UpdateCreditSuccess,DeleteCredit,DeleteCreditFailure,DeleteCreditSuccess,CreateCredit,CreateCreditFailure,CreateCreditSuccess } from '../actions/credit.actions';

@Injectable()
export class CreditEffects {
  constructor(
    private actions$: Actions,
    private service: CreditService
  ) { }

  /** 🔹 Get All */

  
  loadCredit$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(CreditActionTypes.LoadCredits),
    mergeMap((action: LoadCredits) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryCreditModel>) => {
          if (!res || !res.isSuccess) {
              return new LoadCreditsFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadCreditsSuccess({
              items: res.values,
              total: res.total
            });
          }),
          catchError(error => of(new LoadCreditsFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadCreditById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(CreditActionTypes.LoadCredit),
        mergeMap((action: LoadCredit) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadCreditSuccess(response)),
            catchError(error => of(new LoadCreditFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updateCredit$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(CreditActionTypes.UpdateCredit),
          mergeMap((action: UpdateCredit) =>
            this.service.update(action.payload.credit).pipe(
              switchMap(updated => [
                new UpdateCreditSuccess({ credit: updated }),
              ]),
              catchError(error => of(new UpdateCreditFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deleteCredit$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(CreditActionTypes.DeleteCredit),
          mergeMap((action: DeleteCredit) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteCreditSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteCreditFailure({ error })))
            )
          )
        ));



}
